function calculateAspectRatioFit (srcWidth, srcHeight, maxWidth, maxHeight) {
  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
  return { targetWidth: ratio >= 1 ? srcWidth : srcWidth * ratio, targetHeight: ratio >= 1 ? srcHeight : srcHeight * ratio }
}

async function resizeBase64Image (base64Str) {
  return new Promise((resolve) => {
    const img = new window.Image()
    img.src = base64Str
    img.onload = () => {
      const MAX_WIDTH = 700
      const MAX_HEIGHT = 700
      const { targetWidth, targetHeight } = calculateAspectRatioFit(img.width, img.height, MAX_WIDTH, MAX_HEIGHT)
     
      if (targetWidth >= img.width && targetHeight >= img.height) {
        return resolve(base64Str)
      }

      const canvas = document.createElement('canvas')
      canvas.width = targetWidth
      canvas.height = targetHeight
      const ctx = canvas.getContext('2d')
      ctx.imageSmoothingEnabled = true
      ctx.imageSmoothingQuality = 'high'
      ctx.drawImage(img, 0, 0, targetWidth, targetHeight)
      resolve(canvas.toDataURL('image/png'))
    }
  })
}

export {
  resizeBase64Image
}
